$(document).ready(function(){

	$('[data-fancybox]').fancybox({
		thumbs : {
			autoStart : true
		}
	});

});